export const getProductUiUrl = (productPublicId: string) =>
  `/products/list?q=${productPublicId}&size=n_15_n`;
